import { NgModule } from '@angular/core';
import { ImageCropperModule } from 'ngx-image-cropper';
import { NgxFileDropModule } from 'ngx-file-drop';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SharedModule } from '@shared/shared.module';
import { U2bImageCropperDialogComponent } from './image-cropper-dialog.component';

@NgModule({
    declarations: [
        U2bImageCropperDialogComponent
    ],
    imports: [
        ImageCropperModule,
        NgxFileDropModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MatToolbarModule,
        MatProgressBarModule,
        FuseSharedModule,
        MatProgressSpinnerModule,
        SharedModule
    ],
})
export class U2bImageCropperDialogModule {
}
